<template>
  <div class="data-card">
    <div class="data-card__header">
      <h3 class="my-0">{{item.name}}</h3>
      <div>
        <el-button v-if="isEdited" type="primary" size="medium" :loading="updateProgress" @click="onSave">
          Сохранить
        </el-button>
        <el-button v-else size="medium" @click="isEdited=true" :loading="updateProgress">
          Изменить
        </el-button>
      </div>
    </div>

    <div class="mt-4">
      <el-form :model="form" :rules="rules" ref="form">
        <table :class="['card-table card-table_border text-secondary', {'is-edited': isEdited}]">
          <tr>
            <td>Статус</td>
            <td class="p-0">
              <el-form-item prop="isActive" class="no-mb">
                <el-select size="medium"
                           :disabled="!isEdited"
                           class="w-100"
                           :class="activeStatuses.find(s => s.value === !!form.isActive).cssClass"
                           @change="onChangeActive"
                           :value="form.isActive"
                           placeholder="Статус">
                  <el-option
                    v-for="option in activeStatuses"
                    :key="option.id"
                    :class="option.cssClass"
                    :label="option.label"
                    :value="option.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>Название подрядчика</td>
            <td>
              <el-form-item v-if="isEdited" prop="name" class="no-mb">
                <el-input size="medium" placeholder="Название подрядчика" v-model="form.name" />
              </el-form-item>
              <span v-else>{{item.name}}</span>
            </td>
          </tr>
          <tr>
            <td>Идентификатор подрядчика</td>
            <td>
              <el-form-item v-if="isEdited" prop="identifier" class="no-mb">
                <el-input size="medium" placeholder="Идентификатор подрядчика" v-model="form.identifier" />
              </el-form-item>
              <span v-else>{{item.identifier}}</span>
            </td>
          </tr>
          <tr>
            <td>Регион</td>
            <td>
              <el-form-item v-if="isEdited" prop="region" class="no-mb">
                <el-input size="medium" placeholder="Регион" :value="form.region" @input="form.region = replaceNumber($event)" />
              </el-form-item>
              <span v-else>{{item.region}}</span>
            </td>
          </tr>

          <tr>
            <td>Комментарий</td>
            <td>
              <el-form-item v-if="isEdited" prop="comment" class="no-mb">
                <el-input type="textarea"
                          size="medium"
                          :rows="4"
                          maxlength="200"
                          show-word-limit
                          placeholder="Комментарий"
                          v-model="form.comment"
                          resize="none"/>
              </el-form-item>
              <span v-else>{{item.comment}}</span>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import activeStatuses from '@/commons/constants/activeStatuses';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { replaceNumber } from '@/commons/helpers';

export default {
  data: () => ({
    isEdited: false,

    form: {
      id: '',
      isActive: true,
      name: '',
      identifier: null,
      region: null,
      comment: '',
    },
    activeStatuses,

    rules: {
      name: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
      identifier: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
      region: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
  }),

  created() {
    this.fillForm();
  },

  computed: {
    ...mapGetters({
      item: 'contractors/item',
      updateProgress: 'contractors/updateProgress',
    }),
  },

  methods: {
    ...mapActions({
      updateItem: 'contractors/updateItem',
    }),
    fillForm() {
      this.form.id = this.item.id;
      this.form.isActive = this.item.isActive;
      this.form.name = this.item.name;
      this.form.identifier = this.item.identifier;
      this.form.region = this.item.region;
      this.form.comment = this.item.comment;
    },
    onChangeActive(item) {
      this.form.isActive = item;
    },
    replaceNumber,
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {
            ...this.form,
          };
          this.updateItem({ id: this.item.id, data })
            .then(() => {
              this.isEdited = false;
            }).catch(() => {});
        }
      });
    },
  },

  watch: {
    item() {
      this.isEdited = false;
      this.fillForm();
    },
  },
};
</script>
